import './App.css';
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
import Home from "./pages/Site/Home/Home";
import Programs from "./pages/Site/programs/Programs";
import ContactUs from "./pages/Site/ContactUs/ContactUs";
import MainLayout from "./layout/MainLayout";
import {useEffect} from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {useDispatch} from "react-redux";
import {GetState, SetState} from "./redux/reduxhelper";
import Events from "./pages/Site/Events/Events";
import {scrollToTop} from "./tools/helper";
import LoginLayout from "./layout/LoginLayout";
import DashboardLayout from "./layout/DashboardLayout";
import Index from "./pages/Admin/auth/login";
import IndexSignup from "./pages/Admin/auth/signup";
import IndexRecovery from "./pages/Admin/auth/recovery";

import DashboardHome from "./pages/Admin/dashboard/home/DashboardHome";
import DashboardEvents from "./pages/Admin/dashboard/events/DashboardEvents";
import DashboardTickets from "./pages/Admin/dashboard/tickets/DashboardTickets";
import DashboardPrograms from "./pages/Admin/dashboard/programs/DashboardPrograms";
import DashboardCustomers from "./pages/Admin/dashboard/customers/DashboardCustomers";
import DashboardOurTarget from "./pages/Admin/dashboard/ourTarget/DashboardOurTarget";
import DashboardAboutUs from "./pages/Admin/dashboard/aboutUs/DashboardAboutUs";

import {BLOCK_FETCHING, IS_AUTH} from "./redux/action/type.action";
import Details from "./pages/Admin/dashboard/events/Details";
import TicketDetails from "./pages/Admin/dashboard/tickets/Details";
import DashboardRegistrants from "./pages/Admin/dashboard/registrants/DashboardRegistrants";
import {useDebounceEffect} from "./hoc/useDebounceEffect";
import {Backdrop} from "@mui/material";
import Loading from "./components/Site/Loading/Loading";

function App() {

    const location = useLocation();
    const dispatch = useDispatch();
    const fn = async () => dispatch(SetState('path_name', location.pathname + location.hash));
    const blockFetchingOpen = GetState(BLOCK_FETCHING, false);

    useDebounceEffect(async () => {
        await fn();
    },20, [location]);


    useEffect(() => {
        scrollToTop();
        // execute on location change
        setTimeout(() => {
            if (window.location.hash) {
                document.getElementById('about_us').scrollIntoView({behavior: 'smooth', block: 'start'})
            } else {
                // Fragment doesn't exist
            }
        }, 500)

    }, [location]);


    useEffect(() => {
        AOS.init();
        AOS.refresh();
    }, []);

    let Auth = GetState(IS_AUTH, false);
    return (
        <>
            <Backdrop
                onClick={() => dispatch(SetState(BLOCK_FETCHING, false))}
                open={blockFetchingOpen}
                sx={{zIndex: 2000}}
            >
                <Loading sx={{color: '#a5e757'}}/>
            </Backdrop>

            <Routes>
                <Route exact path={'/'} element={<MainLayout/>}>
                    <Route path="/" element={<Home/>}/>
                    <Route path="/programs/:programId" element={<Programs/>}/>
                    {/*<Route path="/plans/:blog-post" element={<BlogPost/>}/>*/}
                    <Route path="/events" element={<Events/>}/>
                    <Route path="/contact-us" element={<ContactUs/>}/>
                    {/*<Route path="*" element={<NotFoundPage/>}/>*/}
                </Route>


                {Auth === false ?

                    <>
                        <Route exact path={'/admin'} element={<LoginLayout/>}>
                            <Route path="/admin/login" element={<Index/>}/>
                            <Route path="/admin/recovery" element={<IndexRecovery/>}/>
                            <Route path="/admin/signup" element={<IndexSignup/>}/>
                        </Route>
                        <Route path='*' element={<Navigate to={'/admin/login'}/>}/>
                    </>

                    : <>
                        <Route exact path={'/admin/dashboard'} element={<DashboardLayout/>}>
                            <Route index path="/admin/dashboard/home" element={<DashboardHome/>}/>
                            <Route path="/admin/dashboard/events" element={<DashboardEvents/>}/>
                            <Route path="/admin/dashboard/event/:itemId" element={<Details/>}/>
                            <Route path="/admin/dashboard/event/add" element={<Details/>}/>
                            <Route path="/admin/dashboard/programs" element={<DashboardPrograms/>}/>
                            <Route path="/admin/dashboard/tickets" element={<DashboardTickets/>}/>
                            <Route path="/admin/dashboard/ticket/:id" element={<TicketDetails/>}/>
                            <Route path="/admin/dashboard/ticket/info" element={<TicketDetails/>}/>
                            <Route path="/admin/dashboard/customers" element={<DashboardCustomers/>}/>
                            <Route path="/admin/dashboard/about-us" element={<DashboardAboutUs/>}/>
                            <Route path="/admin/dashboard/our-target" element={<DashboardOurTarget/>}/>
                            <Route path="/admin/dashboard/subscribers" element={<DashboardRegistrants/>}/>
                            {/*<Route path="/admin/dashboard/*" element={<DashboardHome/>}/>*/}
                        </Route>
                        <Route path='*' element={<Navigate to={'/admin/dashboard/events'}/>}/>
                    </>
                }
            </Routes>
        </>
    )
        ;
}

export default App;


